/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('revenuePlanningCtrl', revenuePlanningCtrl);

    revenuePlanningCtrl.$inject = ['$stateParams','linkService','tabRevenue','modelAircrafts','categories','revenuePlanningService','routesItineraries','AuthServerProvider'];

    function revenuePlanningCtrl($stateParams,linkService,tabRevenue,modelAircrafts,categories,revenuePlanningService,routesItineraries,AuthServerProvider){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabRevenue;
        vm.itineraryFlights = getItineraryFlights(vm.linkService,
            ((routesItineraries.data._embedded) ? routesItineraries.data._embedded.routeItineraries : []),categories);
        vm.modelAircrafts = modelAircrafts.data._embedded.modelAircrafts;
        vm.categories = categories;
        vm.editIndexX = -1;
        vm.auxSegments = [];
        vm.pages = routesItineraries.data.page;
        vm.makerId_modelId = $stateParams.makerId_modelId;

        vm.userAccount = AuthServerProvider.getUserAccount();

        for(var c=0; c<vm.modelAircrafts.length; c++){
            vm.modelAircrafts[c].makerId_modelId = vm.linkService.getLinkId(vm.modelAircrafts[c]._links.self.href)
        }

        vm.editSegmentItineraryClass = function(indexX){
            if(vm.editIndexX == indexX || vm.editIndexX == -1){
                vm.itineraryFlights[indexX].disabledClass = false;
                vm.itineraryFlights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.itineraryFlights[indexX].segmentDays[0].segments);
            }
        }

        vm.cancelSegmentItineraryClass = function(indexX){
            vm.itineraryFlights[indexX].segmentDays[0].segments = angular.copy(vm.auxSegments);
            vm.itineraryFlights[indexX].disabledClass = true;
            vm.itineraryFlights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.auxSegments = [];
        }

        vm.saveSegmentItinerary = function(valid,indexX){
            if(valid){
                var saveSegment = angular.copy(vm.itineraryFlights[indexX].segmentDays[0].segments);
                for(var i=1; i<vm.itineraryFlights[indexX].segmentDays.length; i++){
                    for(var j=0;j<vm.itineraryFlights[indexX].segmentDays[i].segments.length;j++){
                        saveSegment.push(
                            {
                                "id": vm.itineraryFlights[indexX].segmentDays[i].segments[j].id,
                                "capacities": saveSegment[j].capacities
                            }
                        )
                    }
                }

                revenuePlanningService.updateSegmentItineraries(saveSegment, vm.userAccount.userName)
                    .then(function(res){
                        if(res != "ok"){
                            vm.itineraryFlights[indexX].segmentDays[0].segments = angular.copy(vm.auxSegments);
                        }
                        vm.itineraryFlights[indexX].disabledClass = true;
                        vm.itineraryFlights[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                    });

            }
        }

        vm.getModelAircraft = function(){
            if(vm.makerId_modelId == null){
                linkService.reloadRoute(linkService.getCurrentRouteName(), {id: $stateParams.id, page: 0, size: 10, makerId_modelId: ''});
            }else{
                linkService.reloadRoute(linkService.getCurrentRouteName(), {id: $stateParams.id, makerId_modelId: vm.makerId_modelId, page: 0, size: 10});
            }
        }
    }

    function getItineraryFlights(linkService,itineraryFlights,categories){
        var segmentItineraries = [];
        for(var i=0; i<itineraryFlights.length; i++){
            segmentItineraries.push(
                {
                    "flightNumber": itineraryFlights[i].flightNumber,
                    "structure": itineraryFlights[i]._embedded.structure,
                    "disabledClass": true,
                    "disabledEdit": false,
                    "showEdit": true,
                    "showSave": false,
                    "segmentDays":[]
                }
            )
            var bandDay = "";
            for(var j=0; j<itineraryFlights[i]._embedded.departuresItinerary.length; j++){
                var dI = itineraryFlights[i]._embedded.departuresItinerary[j];

                if(bandDay == dI.dayOfWeekId){
                    for(var k=0; k<dI._embedded.segmentItineraries.length; k++){
                        var sI = dI._embedded.segmentItineraries[k];
                        segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.push(
                            {
                                "name": sI._embedded.segment.name,
                                "initials": sI._embedded.segment.initials,
                                "id": linkService.getLinkId(sI._links.self.href),
                                "departureTime": (dI.departureTime).substr(0,5),
                                "takeoffCapacity":sI.takeOffCapacity,
                                "capacities": []
                            }
                        );
                        //classes
                        for(var c=0; c<categories.length; c++){
                            for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                                var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href)
                                segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments[segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.length-1].capacities.push(
                                    {
                                        "iataCode": categories[c]._embedded.fareClasses[cl].iataCode,
                                        "classId": classId,
                                        "value": getValueClass(classId,sI._embedded.segmentClassItis)
                                    }
                                );
                            }
                        }
                    }
                }else{
                    segmentItineraries[i].segmentDays.push(
                        {
                            "segments": []
                        }
                    );
                    for(var k=0; k<dI._embedded.segmentItineraries.length; k++){
                        var sI = dI._embedded.segmentItineraries[k];
                        segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.push(
                            {
                                "name": sI._embedded.segment.name,
                                "initials": sI._embedded.segment.initials,
                                "id": linkService.getLinkId(sI._links.self.href),
                                "departureTime": (dI.departureTime).substr(0,5),
                                "takeoffCapacity":sI.takeOffCapacity,
                                "capacities": []
                            }
                        );
                        //classes
                        for(var c=0; c<categories.length; c++){
                            for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                                var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href)
                                segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments[segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.length-1].capacities.push(
                                    {
                                        "iataCode": categories[c]._embedded.fareClasses[cl].iataCode,
                                        "classId": classId,
                                        "value": getValueClass(classId,sI._embedded.segmentClassItis)
                                    }
                                );
                            }
                        }
                    }
                    bandDay = dI.dayOfWeekId;
                }
            }
        }
        return segmentItineraries;
    }

    function getValueClass(classId,segmentClassItis){
        var res = 0;
        if(segmentClassItis != undefined) {
            for (var i = 0; i < segmentClassItis.length; i++) {
                if (segmentClassItis[i].classId == classId) {
                    res = parseInt(segmentClassItis[i].value);
                    break;
                }
            }
        }
        return res;
    }
})();
